import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/linkedin-headline-generator/LinkedInHeadlineContent.tsx");
